//= require bijou/cjs_shim
//= require bijou/jquery.validate
//= require bijou/jspostcode

require('../../../../../vendor/assets/javascripts/bijou/jquery.validate')
require('../../../../../vendor/assets/javascripts/bijou/jspostcode')

;(function ($, checkPostCode) {
  'use strict'

  function parseDate (dateString, countryCode, inputType) {
    var dateFormat = {
      'en-GB': { 'day': 0, 'month': 1, 'year': 2, 'format': /^\d?\d\/\d?\d\/\d\d\d\d$/ },
      'en-US': { 'day': 1, 'month': 0, 'year': 2, 'format': /^\d?\d\/\d?\d\/\d\d\d\d$/ },
      'iso8601': { 'day': 2, 'month': 1, 'year': 0, 'format': /^\d\d\d\d\/\d?\d\/\d?\d$/ }
    }

    // The date input value follows the same pattern yyyy-mm-dd even if the
    // input shows it in a different format
    if (inputType === 'date') {
      return new Date(dateString)
    }

    if (!dateString.match(dateFormat[countryCode]['format'])) {
      return new Date(NaN)
    }
    var dateParts = dateString.split('/')

    if (dateParts.length !== 3) {
      return new Date(NaN)
    }

    var year = parseInt(dateParts[dateFormat[countryCode]['year']], 10)
    var month = parseInt(dateParts[dateFormat[countryCode]['month']], 10) - 1
    var day = parseInt(dateParts[dateFormat[countryCode]['day']], 10)

    if (isNaN(year) || isNaN(month) || isNaN(day)) {
      return new Date(NaN)
    }

    var date = new Date(year, month, day)

    if (day !== date.getDate() || month !== date.getMonth() || year !== date.getFullYear()) {
      return new Date(NaN)
    }
    return date
  }

  function getDateAsInteger (dateString, countryCode, inputType) {
    return parseDate(dateString, countryCode, inputType).getTime()
  }

  function workersCompensationQuestionnaire() {
    return $("body").hasClass("workers_compensation");
  }
  function hasAtLeastTwoUniqueDigits(value) {
    const uniqueDigits = new Set(value.replace(/\D/g, ''));
    return uniqueDigits.size >= 2;
  }
  // The original focusInvalid method is flawed as it does not work well in
  // iOS devices (focus is moved to input but it does not scroll it into view)
  // This fixes the iOS issue but also allows the method to be overridden.
  $.validator.prototype.focusInvalid = function () {
    if (this.settings.focusInvalid) {
      var el = $(this.findLastActive() || (this.errorList.length && this.errorList[0].element) || [])
        .filter(':visible')

      if (el.length) {
        if (typeof (this.settings.focusInvalid) === 'function') {
          this.settings.focusInvalid(el)
        } else {
          try {
            el.get(0).scrollIntoView()
            // manually trigger focusin event; without it, focusin handler
            // isn't called, findLastActive won't have anything to find
            el.focus().trigger('focusin')
          } catch (e) {
            // ignore IE throwing errors when focusing hidden elements
          }
        }
      }
    }
  }

  $.validator.prototype.resetField = function (element) {
    this.settings.unhighlight.call(this, element[0], this.settings.errorClass, this.settings.validClass)
    this.toHide = this.toHide.add(this.errorsFor(element[0]))
    this.hideErrors()
  }

  $.validator.addMethod('not', function (value, element, params) {
    return this.optional(element) || value !== params
  }, $.validator.format('Please enter another value than {0}.'))

  // NOTE: ideally this will be temporary, as all currency fields should support decimals
  $.validator.addMethod('currency_without_decimals', function (value, element) {
    return this.optional(element) || /^£?[0-9]+(,[0-9]{3})*$/.test(value)
  }, 'Please enter a value in pounds.')

  $.validator.addMethod('currency', function (value, element) {
    return this.optional(element) || /^£?[0-9]+(,[0-9]{3})*(\.[0-9]+)?$/.test(value)
  }, 'Please enter a value in pounds.')

  $.validator.addMethod('free_text_currency', function (value, element) {
    var valueWithoutCommas = value.replace(/,/g, '')
    return this.optional(element) || /^[0-9]*$/.test(valueWithoutCommas)
  }, 'Please enter a currency value')

  $.validator.addMethod('postcode', function (value, element) {
    return this.optional(element) || checkPostCode($.trim(value))
  }, 'Please enter a valid postcode')

  /* GoingPostal gem (Riddler answer type validation) accepts only short form zipcodes (5 digits).
  jQuery mask (with our setup in /bijou/smart_form/masking.js) will prevent
  other formats from being passed to the front end. */
  $.validator.addMethod('zipcode', function (value, element) {
    return this.optional(element) || /^[0-9]{5}$/.test(value)
  }, 'Please enter a valid zipcode')

  $.validator.addMethod('date', function (value, element) {
    var inputType = element.getAttribute('type')
    return this.optional(element) || !isNaN(getDateAsInteger(value, $(element).data('dateFormat'), inputType))
  }, 'Please enter a valid date')

  $.validator.addMethod('mindate', function (value, element, mindate) {
    var dateFormatConfig = $(element).data('dateFormat')
    var inputType = element.getAttribute('type')
    return this.optional(element) || getDateAsInteger(value, dateFormatConfig, inputType) >= getDateAsInteger(mindate, dateFormatConfig, inputType)
  }, 'Please enter a valid date')

  $.validator.addMethod('maxdate', function (value, element, maxdate) {
    var dateFormatConfig = $(element).data('dateFormat')
    var inputType = element.getAttribute('type')
    return this.optional(element) || getDateAsInteger(value, dateFormatConfig, inputType) <= getDateAsInteger(maxdate, dateFormatConfig, inputType)
  }, 'Please enter a valid date')

  /*  NOTE:  if the regex here is changed, the corresponding one in X-Rated must
   *  be changed as well (in `answer_types.rb`) */
  $.validator.addMethod('uk_telephone_number', function (value, element) {
    var telephoneRegex = (/^(\+44|0044|44|0)[\d\-()]{9,11}$|^(\+|00)[\d\-()]{5,20}$/)
    var sanitizedValue = value.replace(/[-()\s]/g, '')
    return this.optional(element) || telephoneRegex.test(sanitizedValue)
  }, 'Please enter a valid phone number')

  /* jQuery mask (with our setup in /bijou/smart_form/masking.js) will prevent
  other formats from being passed to the front end. */
  $.validator.addMethod('us_telephone_number', function (value, element) {
    if (workersCompensationQuestionnaire()){
      return this.optional(element) || (hasAtLeastTwoUniqueDigits(value) && /^\([2-9][\d]{2}\)\s[\d]{3}-[\d]{4}$/.test(value))
    }

    return this.optional(element) || /^\([\d]{3}\)\s[\d]{3}-[\d]{4}$/.test(value)
  }, 'Please enter a valid phone number')

  // Validate policy number formatting
  $.validator.addMethod('pol_num', function (value, element) {
    return /^(?:[A-Z]{2}|[A-Z]{4})\d{6,7}[A-Z]{2}\d{0,2}$/i.test(value.trim())
  }, 'Invalid policy number. Policy numbers begin with 2 or 4 letters, followed by 6 or 7 digits, followed by 2 letters and an optional 1 or 2 digits.')

  // Validate email, '@xn--' check is for punycode case with Chrome browser
  $.validator.addMethod('email', function (value, element) {
    var emailRegex = /^[a-z0-9.!#$%&'*+/=?^_`{|}~-]+@(?!xn--)[a-z0-9](?:[a-z0-9_-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])){1,}$/i

    return emailRegex.test(value)
  }, 'Please enter a valid email address')
}(window.jQuery, window.checkPostCode))
